import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"display\":\"swap\",\"preload\":false,\"style\":[\"normal\",\"italic\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"subsets\":[\"latin\",\"latin-ext\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_app.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/index.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/vendors.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/filepond/dist/filepond.min.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layouts/Wrapper/Wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/router/AsideRouter.tsx");
